import type { AttentionArea, AttentionItem, AttentionSeverity } from '@/api/adminClient';

const SEVERITY_ORDER: Record<AttentionSeverity, number> = { critical: 0, warning: 1, info: 2 };

/** The worst severity among an area's rows; undefined when it has none. */
export function worstSeverity(items: AttentionItem[] | undefined, area: AttentionArea | undefined): AttentionSeverity | undefined {
  if (!items || !area) return undefined;
  let worst: AttentionSeverity | undefined;
  for (const item of items) {
    if (item.area !== area) continue;
    if (!worst || SEVERITY_ORDER[item.severity] < SEVERITY_ORDER[worst]) worst = item.severity;
  }
  return worst;
}

export const SEVERITY_LABELS: Record<AttentionSeverity, string> = {
  critical: 'Urgent',
  warning: 'Needs a look',
  info: 'FYI',
};

const AREA_LABELS: Record<AttentionArea, string> = {
  organizations: 'billing',
  integrations: 'integration drafts',
  templates: 'templates',
  platform: 'the platform',
  tokenHealth: 'connected accounts',
};

/** "Could not check billing and templates just now." for the areas the API could not read. */
export function unavailableNotice(areas: AttentionArea[] | undefined): string | undefined {
  if (!areas || areas.length === 0) return undefined;
  const names = areas.map((area) => AREA_LABELS[area]);
  const list = names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
  return `Could not check ${list} just now, so this list may be missing something.`;
}

const ACTION_LABELS: Record<AttentionArea, string> = {
  organizations: 'Open billing',
  integrations: 'Review',
  templates: 'Review',
  platform: 'Open Platform',
  tokenHealth: 'Open Token health',
};

export function actionLabel(area: AttentionArea): string {
  return ACTION_LABELS[area] ?? 'Open';
}
